import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import 'i18n/config';
import 'simplebar-react/dist/simplebar.min.css';
import 'styles/index.css';
import 'styles/custom.css';
import 'styles/map-animations.css';

// Import theme CSS based on environment variable
const clientTheme = import.meta.env.VITE_CLIENT_THEME || 'henddu';

// Dynamic theme import using template literal
import(`./styles/themes/${clientTheme}.css`).then(() => {
}).catch((error) => {
  import('./styles/themes/henddu.css');
});

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { PrimeReactProvider } from 'primereact/api';
import 'primereact/resources/primereact.css';
import 'primereact/resources/themes/lara-light-indigo/theme.css';
import initFetchInterceptor from 'utils/fetchInterceptor';


const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      refetchOnWindowFocus: false,
    },
  },
});

// Initialize fetch interceptor early
initFetchInterceptor();

ReactDOM.createRoot(document.getElementById('root')).render(
  <PrimeReactProvider>
    <QueryClientProvider client={queryClient}>
      <React.StrictMode>
          <App />
      </React.StrictMode>
      <ReactQueryDevtools />
    </QueryClientProvider>
  </PrimeReactProvider>
);
